import classNames from "classnames";
import React from "react";
import { ExistingTagGroupFormType } from "../../types";
import tagGroupsStyles from "../tagGroups.css";
import settingsStyles from "../../../../../../styles/settings.css";
import { intl } from "@fidget/common/i18n/TypedIntl";
import styles from "./groupNameColumn.css";
import { ChipTagGroup } from "../../../../../chip/presets/ChipTagGroup/ChipTagGroup";

interface Props {
  form: ExistingTagGroupFormType;
}
export const GroupNameColumn = ({ form }: Props) => {
  return (
    <div className={classNames(tagGroupsStyles.column, styles.column)}>
      <p className={classNames(tagGroupsStyles["label-margin"], settingsStyles["form-label-font"])}>
        {intl.formatMessage("settings.tagGroups.form.name.label")}
      </p>
      <ChipTagGroup name={form.$.name.$} enabled={form.$.active.$} />
    </div>
  );
};
